import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function checkSubAgentList(params) {
  return authPost(`${baseUrl}/Agent1.ashx`, params);
}

export function checkSubAgentDetails(params) {
  return authPost(`${baseUrl}/Agent23.ashx`, params);
}

export function subAgentTelegramUnbind(params) {
  return authPost(`${baseUrl}/Agent23.ashx`, params);
}
